// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/certify.css
// module id = wr0d
// module chunks = 12